module.exports = __webpack_public_path__ + "img/logo-CRM-lead.2efb63ac.jpg";